<template>
  <div v-if="showAlert" class="alert-wrapper">
    <base-alert type="primary">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-center justify-content-between gap-3">
          <div class="d-flex align-items-center gap-2">
          <span class="text-xl mr-3 animate-text">🔐</span>
          <span class="display-5 animate-text">
            Jetzt eigenen <strong class="text-pulse">Socialguard</strong> Zugang einrichten!
          </span>
        </div>
        <a
            href="https://config.socialguard.app"
            target="_blank"
            class="btn btn-danger fw-bold "
        >
          →
        </a>
        </div>
        <button
            v-if="showAbort"
            @click="logout()"
            class="btn btn-sm btn-light mt-4 w-100"
        >
          Demo beenden
        </button>
      </div>
    </base-alert>
  </div>
</template>

<script>
export default {
  name: 'DemoToast',
  data() {
    return {
      showAlert: false,
      showAbort: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.showAlert = true
      }, 3000)
    setTimeout(() => {
        this.showAbort = true
      }, 30000)
  },
  methods: {
    handleClick() {
    window.location.href = 'https://config.socialguard.app'
    },
    logout() {
      this.$store.dispatch('profiles/setNoActiveProfile').then(() => {
        this.$store.dispatch('authentication/logout');
        this.allowMultipleInstances();
        location.reload();
      });
    }
  }
}
</script>

<style scoped>
.alert-wrapper {
  position: fixed;
  bottom: env(safe-area-inset-bottom, 20px);
  left: env(safe-area-inset-left, 20px);
  right: env(safe-area-inset-right, 20px);
  z-index: 9999;
  padding-bottom: env(safe-area-inset-bottom, 0px);
  margin-bottom: 10px;
}


@media (min-width: 768px) {
  .alert-wrapper {
    left: auto;
    right: env(safe-area-inset-right, 20px);
    width: 400px;
  }
}

.animate-text {
  animation: softBlink 2s ease-in-out infinite;
}

@keyframes softBlink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>